<script setup>
import { ref, watchEffect } from "vue";

const props = defineProps({
  visible: Boolean,
  toggleCameraAccessModal: Function
});

const browserSettings = ref(false);
const phoneSettings = ref(false);
const closeApps = ref(false);
const isDisabled = ref(true);

const hostName = typeof window !== "undefined" ? window.location.hostname : "";

watchEffect(() => {
  isDisabled.value = !(browserSettings.value && phoneSettings.value && closeApps.value);
});

const handleReload = () => {
  window.location.reload();
};
</script>

<template>
<div v-if="visible" class="fixed top-10 right-0 bottom-0 left-0 z-[9999] flex items-center justify-center overflow-y-auto bg-white">
  <div class="text_all flex max-h-dvh min-h-full flex-col gap-8 p-5">
    <h1 class="text-center text-2xl font-bold">
      {{ $t("camera_access.title") }}
    </h1>
    <div class="flex flex-col gap-8">
      <div class="flex items-center justify-between gap-3">
        <img src="../../assets/icons/settings.svg" alt="" />
        <p v-html="$t('camera_access.camera_access_browser', { domain: hostName })"></p>
        <input v-model="browserSettings" type="checkbox" />
      </div>
      <div class="self-stretch outline-1 outline-offset-[-0.50px] outline-black/10"></div>

      <div class="flex items-center justify-between gap-3">
        <img src="../../assets/icons/gears.svg" alt="" />
        <p v-html="$t('camera_access.camera_access_phone_setting')"></p>
        <input v-model="phoneSettings" type="checkbox" />
      </div>

      <div class="self-stretch outline-1 outline-offset-[-0.50px] outline-black/10"></div>

      <div class="flex items-center justify-between gap-3">
        <img src="../../assets/icons/cameraClose.svg" alt="" />
        <p v-html="$t('camera_access.close_other_apps')"></p>
        <input v-model="closeApps" type="checkbox" />
      </div>

      <div class="self-stretch outline-1 outline-offset-[-0.50px] outline-black/10"></div>
    </div>
    <div class="flex flex-col items-center gap-2.5 py-6">
      <p class="text-center">
        {{ $t("camera_access.mark_all_steps") }}
      </p>
      <button
        class="inline-table rounded bg-black p-2.5 text-lg leading-none font-bold text-white"
        :class="{ 'bg-black/20': isDisabled }"
        :disabled="isDisabled"
        @click="handleReload()"
      >
        {{ $t("try_again") }}
      </button>
    </div>
  </div>
</div>
</template>
